import React from 'react'
import CategoryLandingSectionList, { normalizeLandingStatItems } from '../../../../components/categoryLanding/CategoryLandingSectionList'

export function buildLayoutConfig(layoutKey, incomingConfig = {}, defaults = {}) {
  return {
    ...defaults,
    ...(incomingConfig || {}),
    templateStyle: layoutKey,
  }
}

export function splitHighlightSection(sections = [], enabled = false) {
  if (!enabled) return { highlightSection: null, bodySections: Array.isArray(sections) ? sections : [] }
  const safeSections = Array.isArray(sections) ? sections : []
  const highlightSectionIndex = safeSections.findIndex((sec) => (
    ['icon-grid', 'benefit-cards'].includes(String(sec?.type || '').toLowerCase()) && Array.isArray(sec?.items)
  ))
  return {
    highlightSection: highlightSectionIndex >= 0 ? safeSections[highlightSectionIndex] : null,
    bodySections: highlightSectionIndex >= 0 ? safeSections.filter((_, idx) => idx !== highlightSectionIndex) : safeSections,
  }
}

export function IntroStatsPanel({ introStats = [] }) {
  const safeStats = normalizeLandingStatItems(introStats)
  if (safeStats.length === 0) return null
  return (
    <div className="rounded-3xl border p-6 md:p-7 bg-white shadow-sm">
      <div className="mb-4 text-xl font-bold text-slate-900">신뢰 지표</div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {safeStats.map((it, idx) => (
          <div key={idx} className="rounded-2xl border p-4 text-center">
            <div className="text-2xl font-extrabold text-slate-900">{it?.value || '-'}</div>
            <div className="mt-2 break-keep break-words text-sm text-slate-500">{it?.label || ''}</div>
          </div>
        ))}
      </div>
    </div>
  )
}

export function LayoutSections({ sections = [], resolveAssetUrl, variant = 'default', filter }) {
  if (!Array.isArray(sections) || sections.length === 0) return null
  return (
    <CategoryLandingSectionList
      sections={sections}
      resolveAssetUrl={resolveAssetUrl}
      variant={variant}
      filter={filter}
    />
  )
}

export const COMMON_LAYOUT_EDITABLE_FIELDS = [
  { key: 'heroBackgroundColor', label: 'Hero 배경색', placeholder: '#f8fafc' },
  { key: 'heroTextColor', label: 'Hero 제목색', placeholder: '#0f172a' },
  { key: 'heroSubtitleColor', label: 'Hero 부제목색', placeholder: '#475569' },
  { key: 'formBorderColor', label: '폼 테두리색', placeholder: '#3b82f6' },
  { key: 'formBorderWidth', label: '폼 테두리 두께', placeholder: '3', type: 'number' },
]
